// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://7601eefb21c35f334850e5be8dc9e981@sentry-v2.leadhub.cz/39',

  // Replay is the heaviest Sentry integration (~50+ KiB). Loaded lazily below after
  // the browser is idle so initial bundle stays small and TTI/INP stay fast.
  integrations: [],

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Skip session sampling in production — Replay chunk (~48 KB) only loads
  // for sessions that actually hit an error, keeping it off the critical path
  // for everyone else. Dev keeps 10 % so we can still verify replays locally.
  replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0 : 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true
});

// Defer Replay integration load until the browser is idle. Errors reported
// before Replay is ready are still captured by the Sentry core and get a
// replay attached retroactively once Replay initialises.
if (typeof window !== 'undefined') {
  const loadReplay = () => {
    Sentry.lazyLoadIntegration('replayIntegration')
      .then((replayIntegration) => {
        Sentry.addIntegration(replayIntegration());
      })
      .catch(() => {
        // Replay is non-critical — errors are still reported without it
      });
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(loadReplay, { timeout: 5000 });
  } else {
    setTimeout(loadReplay, 3000);
  }
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
